var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mb-2 font-serif text-3xl font-bold tracking-tight text-neutral-900 lg:text-4xl"},[_vm._t("title")],2),_c('p',{staticClass:"text-sm text-neutral-600 sm:text-base-relaxed"},[_vm._t("description")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }